import { render, staticRenderFns } from "./chatbotConfiguration.vue?vue&type=template&id=0b7d5984&scoped=true&"
import script from "./chatbotConfiguration.vue?vue&type=script&lang=js&"
export * from "./chatbotConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./chatbotConfiguration.vue?vue&type=style&index=0&id=0b7d5984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7d5984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b7d5984')) {
      api.createRecord('0b7d5984', component.options)
    } else {
      api.reload('0b7d5984', component.options)
    }
    module.hot.accept("./chatbotConfiguration.vue?vue&type=template&id=0b7d5984&scoped=true&", function () {
      api.rerender('0b7d5984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chatbotManagement/chatbotConfiguration.vue"
export default component.exports